// themes.js
export const themes = {
bo3: {
    name: "Black Ops 3",
    images: {
        logo: "https://cdn.spookytools.com/themes/BO3/spooky-tools-logo.png",
        tools: "https://cdn.spookytools.com/themes/BO3/tools.png"
    },
    audio: {
    background: "https://cdn.spookytools.com/assets/BO3.mp3",
    volume: 0.1
    },
    video: {
    background: "https://cdn.spookytools.com/assets/bo3.mp4",
    transition: "https://cdn.spookytools.com/assets/firetransition.mp4",
    transitionDuration: 1500,
    transitionPause: 333
    },
    styles: {
        menu: {
            logo: {
                width: "700px",
                marginLeft: "-40px",
                padding: "pt-12 pb-8 px-6"  // Added padding for logo
            },
            activeTab: "text-orange-500",
            inactiveTab: "text-orange-900 hover:text-orange-600",
          card: {
            border: "border-red-600/50",
            background: "bg-black/70",
            shadow: "shadow-red-900/50"
          },
          button: {
            background: "bg-black/80",
            hover: "group-hover:bg-red-900/70",
            border: "border-red-900/50",
            shadowColor: "rgba(255, 0, 0, 0.7)" // Red shadow for BO3 theme
          },
          indicator: {
            color: "bg-red-600"
          }
        },
        overlay: "bg-black/30"
    }
},
arcane: {
    name: "Arcane",
    images: {
      logo: "https://cdn.spookytools.com/themes/Arcane/spooky-tools-logo.png",
      tools: "https://cdn.spookytools.com/themes/Arcane/tools.png"
    },
    audio: {
      background: "https://cdn.spookytools.com/themes/Arcane/arcane.mp3",
      volume: 0.08
    },
    video: {
      background: "https://cdn.spookytools.com/themes/Arcane/arcane_apo8.mp4",
      transition: "https://cdn.spookytools.com/themes/Arcane/transitions.mp4",
      transitionDuration: 1500,
      transitionPause: 333
    },
    styles: {
      menu: {
        social: {
            background: "bg-zinc-900/90",
            border: "border-violet-600/50",
            hover: "hover:border-violet-400/70",
            text: "text-violet-300",
            hoverText: "hover:text-violet-200",
            shadow: "hover:shadow-violet-900/50"
        },
        logo: {
            width: "700px",
            marginLeft: "-40px",
            padding: "pt-12 pb-8 px-6"  // Added padding for logo
        },
        activeTab: "text-violet-300",
        inactiveTab: "text-violet-700 hover:text-violet-400",
        card: {
          border: "border-violet-500/50",
          background: "bg-zinc-900/90",
          shadow: "shadow-violet-900/50"
        },
        button: {
            background: "bg-zinc-900/90",
            hover: "group-hover:bg-violet-900/70",
            border: "border-violet-600/50",
            shadowColor: "rgba(139, 92, 246, 0.5)" // Violet shadow for Arcane theme
        },
        indicator: {
          color: "bg-violet-500"
        }
      },
      overlay: "bg-zinc-900/60"
    }
}
}